export default __webpack_public_path__ + "static/media/ex.7898f62b.svg";